<template>
  <button
    v-if="!router"
    class="app-button"
    :class="classList"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span><slot /></span>
    <div v-if="loading" class="app-button__loader">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="21.904761904761905 21.904761904761905 43.80952380952381 43.80952380952381"
        style="transform: rotate(0deg)"
      >
        <circle
          fill="transparent"
          cx="43.80952380952381"
          cy="43.80952380952381"
          r="20"
          stroke-width="3.8095238095238093"
          stroke-dasharray="125.664"
          stroke-dashoffset="125.66370614359172px"
          class="v-progress-circular__overlay"
        ></circle>
      </svg>
    </div>
  </button>
  <router-link
    v-else
    class="app-button vm-btn hover"
    :class="classList"
    :to="to"
  >
    <span><slot /></span>
  </router-link>
</template>
<script>
export default {
  inheritAttrs: true,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    textUppercase: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    fontBold: {
      type: Boolean,
      default: false,
    },
    semiTransparent: {
      type: Boolean,
      default: false,
    },
    theme: {
      required: false,
      type: String,
      default: 'primary',
    },
    size: {
      required: false,
      type: String,
      default: 'default',
    },
    to: {
      required: false,
      type: Object,
      default: () => ({
        name: 'home',
      }),
    },
    block: {
      required: false,
      type: Boolean,
      default: false,
    },
    router: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    themes: {
      primary: 'primary',
      login: 'theme-login',
      green: 'theme-green',
      purple: 'theme-purple',
      accent: 'theme-accent',
      white: 'white',
      danger: 'danger',
      lightYellow: 'theme-light-yellow',
    },
    sizes: {
      default: 'v-size--default',
      small: 'app-button-size--sm',
      extraSmall: 'app-button-size--extra-sm',
      large: 'v-size--large',
    },
  }),
  computed: {
    classList() {
      return [
        this.themes[this.theme],
        this.sizes[this.size],
        {
          block: this.block,
          disabled: this.disabled,
          uppercase: this.textUppercase,
          outlined: this.outlined,
          'font-bold': this.fontBold,
          'semi-transparent': this.semiTransparent,
        },
      ]
    },
  },
  emits: ['click'],
}
</script>
